import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import PrivateRoute from './components/VerificaSessao/VerificaSessao';
import Home from './components/main/main';
import MobileHome from './components/mobile/main/main';
import { useMediaQuery } from 'react-responsive';
import SimpleLedPathDesigner from './components/SVGPath/svg_path'; // Importe o componente

function App() {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
  
  // Verificação de ambiente de desenvolvimento
  // Esta condição só será verdadeira em ambiente de desenvolvimento
  const isDevEnvironment = process.env.NODE_ENV === 'development';

  return (
    <Router>
      <Routes>
        {/* Rota protegida para /home */}
        <Route
          path="/home"
          element={
            <PrivateRoute>
              {isMobile ? <MobileHome /> : <Home />}
            </PrivateRoute>
          }
        />
        
        {/* Rota para a ferramenta de desenho LED - apenas em desenvolvimento */}
        {isDevEnvironment && (
          <Route
            path="/dev/led-designer"
            element={<SimpleLedPathDesigner />}
          />
        )}

        {/* Fallback para rotas inválidas */}
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </Router>
  );
}

export default App;